import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals.js';
import { BrowserRouter , Routes, Route } from 'react-router-dom';
import { Suspense } from 'react';
import Trade from './Trade.js'
import Contact from './Contact.jsx'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
        <Suspense fallback={<div>Loading page...</div>}>
          <Routes>
            <Route path="/" element={<App/>}></Route>
            <Route path="/trade" element={<Trade/>} />
            <Route path="/contact" element={<Contact/>} />
          </Routes>      
        </Suspense>
  </BrowserRouter>,
 {/* </React.StrictMode>,  */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
